import { designTokens } from "@itandi/itandi-bb-ui";
import { Alertv2 } from "@itandi/itandi-bb-ui/Alertv2";
import { Buttonv2 } from "@itandi/itandi-bb-ui/Buttonv2";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import { Paragraph } from "@itandi/itandi-bb-ui/Paragraph";
import { useRouter } from "next/router";
import type { ReactNode } from "react";

type Props = {
	alertMessage: ReactNode;
	backToEditPath: string;
	isOpen: boolean;
	onClose: () => void;
};

export function BackToEditConfirmModal({
	alertMessage,
	backToEditPath,
	isOpen,
	onClose
}: Props) {
	const router = useRouter();

	return (
		<Modalv2 isOpen={isOpen} onClose={onClose} size="s">
			<ModalHeader title="見積作成画面へもどる" />
			<ModalBody>
				<Paragraph>見積作成画面へもどります。</Paragraph>
				<Alertv2 mt={designTokens["spacing/s"]} variant="warning">
					<Paragraph>{alertMessage}</Paragraph>
				</Alertv2>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Buttonv2 onClick={onClose} variant="secondary">
						キャンセル
					</Buttonv2>
				}
				rightArea={
					<Buttonv2
						onClick={() => {
							void router.push(backToEditPath);
						}}
						variant="primary"
					>
						見積作成画面へもどる
					</Buttonv2>
				}
			/>
		</Modalv2>
	);
}
